import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-credit-note-briefly-register',
  templateUrl: './credit-note-briefly-register.component.html',
  styleUrl: './credit-note-briefly-register.component.scss'
})
export class CreditNoteBrieflyRegisterComponent {


   CreditNoteForm: any;
    reportType: any;
    advtName: any;
    issueDates: any;
  
    currentDate = new Date();
     constructor(
        private dialogRef: MatDialogRef<CreditNoteBrieflyRegisterComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private service: DigisubservicesService,
        private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
      ) {
      }


      advtCreditRegiInBrieflyFormBeans: any = []
      repName: any;
      startDate: any;
      
      endDate: any;
      offRepName: any;
      issueDates1: any;
      CredittadvtInDTotal: number;
      CredittadvtInDTotalother: number;
      CredittadvtInDTotalAmt: number;
      startDate_contract: any;
      enddate_contract: any;
      CredittadvtInBrieflyTotal: number = 0;
      CredittadvtInBrieflyTotaltds : number = 0;
      CredittadvtInBrieflyTotalother : number = 0;


      ngOnInit(): void {

        debugger
        let repname: any = this.data['repName'];
        
            // Then check if it's not empty and convert to array
            if (repname != "") {
              repname = repname; // This puts the single value in an array
            }
        
            this.reportType = this.data['reportType'];
            this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
            this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
            this.repName = this.data['repName'];
            this.offRepName = this.data['offRepName'];
            this.advtName = this.data['name'];
            this.issueDates = this.data.issueDates;
            this.issueDates1 = this.data['issue_date'];
  
    
        const req: any = {
        "rep_name": this.repName,
        "start_date": this.startDate,
        "end_date": this.endDate,
        "off_rep_name": this.offRepName,
        "issue_name": "",
        "issue_date": this.issueDates1
        }

        this.service.getCreditRegiInBriefly(req).subscribe((data: any) => {
          console.log("ADVT Indetailscredit Data=", data);
          this.advtCreditRegiInBrieflyFormBeans = (data as any);;
    
          // Reset totals
          this.CredittadvtInBrieflyTotal = 0;
          this.CredittadvtInBrieflyTotaltds = 0;
          this.CredittadvtInBrieflyTotalother = 0;
    
          // Calculate totals
          for (let repData of this.advtCreditRegiInBrieflyFormBeans) {
            for (let data1 of repData.rep_data) {
              this.CredittadvtInBrieflyTotal += parseFloat(data1.rec_amt) || 0;
              this.CredittadvtInBrieflyTotaltds += parseFloat(data1.tds_amt) || 0;
              this.CredittadvtInBrieflyTotalother += parseFloat(data1.other_credit_amt) || 0;
    
            }
          }
        });
      }

 exportExcel(fileName: string): void {
  const elt = document.getElementById('print-section') as HTMLTableElement | null;
  if (!elt) {
    console.error('Element with ID "print-section" not found');
    return;
  }

  // Convert table to sheet with raw parsing to preserve formats
  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(elt, { raw: true });

  // Manually convert invoice date cells (dd/mm/yyyy) into actual Excel dates
  Object.keys(ws).forEach((addr) => {
    if (!addr.startsWith('!')) {
      const cell = ws[addr];
      const v = cell.v;
      if (typeof v === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
        const [dd, mm, yyyy] = v.split('/').map(n => parseInt(n, 10));
        const date = new Date(yyyy, mm - 1, dd);
        date.setMilliseconds(0); // Prevent float rounding :contentReference[oaicite:1]{index=1}

        cell.t = 'd';
        cell.v = date;
        cell.z = 'dd/mm/yyyy';
      }
    }
  });

  // Create workbook and trigger download
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}
   


}


